import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { addToBag } from '../../../actions/marketPlaceActions'
import { Translate } from '../../../language'
import Button from '../../../utils/components/Button/Button'
import MoreText from '../../MoreText'
import style from './ProductDetaill.module.css'
import lessCIrcle from '../../../assets/img/lessCIrcle.png';
import plusCircle from '../../../assets/img/plusCircle.png';
import { changeQuantity } from '../../../actions/marketPlaceActions';
import { useHistory } from "react-router-dom";


const ProductDetaill = ({ product, bag }) => {

    const history = useHistory()
    const dispatch = useDispatch()
    const [productBag, setProductBag] = useState();
    let productBagAux;

    const searchProduct = () => {

        productBagAux = bag.filter(item => item._id ===product._id)[0];
        console.log();
        if (!productBagAux) {
            console.log()
            dispatch(addToBag(product));
            searchProduct();
        }
        setProductBag(productBagAux);
    }

    useEffect(() => {
        if (product) {
            searchProduct();
        }

        return () => {

        }
    }, [product])

    return (
        <div className={style.container}>

            <div className="content-img-post-templete scroll-menu">
                <img className='img-post-template' src={product && product.image && product.image.url.origin} alt="" />
            </div>

            <div className="content-info-data-post description-data-post" >
                <div className={style.name}>
                    {product?.name}
                </div>
                <div className="description-data-post">
                    <MoreText text={product?.description}></MoreText>
                </div>

            </div>
            <div></div>
            <div className={`content-options-btns-product-bag ${style.quantity_container}`}>
                <img onClick={() => {
                    if (productBag?.quantity - 1 > 0) {
                        dispatch(changeQuantity(productBag, productBag?.quantity - 1))
                    }

                }} src={lessCIrcle} height={30} alt="" />
                <div className={`quantity-container-product-bag`}>
                    <div className="quantity-product-bag">{productBag?.quantity}</div>
                    <div className="quantity-title-product-bag">Cantidad</div>
                </div>
                <img

                    onClick={() => {
                        dispatch(changeQuantity(productBag, productBag?.quantity + 1))
                    }} src={plusCircle} height={30} alt="" />
            </div>
            <div></div>
            <div className={style.btn_container}>
                <Button onClick={() => history.push('/MarketPlace')} text={Translate('EcobolsaAdd', 'es')} />
            </div>


        </div>
    )
}

export default ProductDetaill